<template>
  <div id="home">
    <!-- 49 -->
    <div class="maxwidth">
      <div class="minwidth">
        <h1>入学文件核对清单</h1>
        <h3>
          In Cooperation with High School Matriculation Documents Checklist
        </h3>
        <div class="text">
          PLEASE NOTE 请注意:<br />
          <div class="title">
            Please complete and submit the following documents within 5 working
            days after receiving the link to the documents. We strongly
            recommend you read, sign and submit the documents as soon as
            possible.
          </div>

          <div class="title">
            请完成填写一下文件，截止日期为收到该文件链接的 5
            个工作日内，我们强烈建议您今天完成下列文件的阅读与签署。
          </div> 
          • Forms must be completed in English. <br />表格必须用英文填写。<br />
          • These forms were written in English. Any translations are provided
          for convenience only and will have no legal effect on the
          interpretation or enforceability of the forms.<br />
          该文件是以英文版发布。为方便理解该文件而提供的任何翻译，其解释性或强制执行性将都不具任何法律效力。<br />
          • Students will not be permitted to attend class or reside in homestay
          until all of these forms are fullycompleted and submitted.
          <br />在还没完整地填写及递交所有文件，在还没完整地填写及递交所有文件，学生不被容许上课或入住住家。
          <div class="title">Please Complete and Return 请填写并缴还:</div>
          <p v-if="Message.page_one">
            Agreement for International Student Homestay
            Program《寄宿家庭项目协议》
          </p>
          <p v-if="Message.page_two">
            Permission for Guardian Power and Medical
            Care《监护人授权和医疗授权同意书》
          </p>
          <p v-if="Message.page_three">
            Permission to Access Student Information《授权成绩单账户查询》
          </p>
          <p v-if="Message.page_four">
            Liability Release《外出知情及免责声明》
          </p>
          <p v-if="Message.page_five">
            Parents Approval for Minor to Travel Alone《独自乘坐飞机授权》
          </p>
          <p v-if="Message.page_six">
            In Cooperation with High School Matriculation Documents
            Confirmation《入学文件确认页》
          </p>
        </div>
        <div class="fenge"></div>
        <div id="Ishp" v-if="Message.page_one && agreementType === '2'">
          <h1>寄宿家庭项目协议</h1>
          <div class="div_radio" v-if="!this.$route.query.type">
            <el-radio v-model="ishp.is_long" :label="1" @change="ChangeRadio">长期住家</el-radio>
            <el-radio v-model="ishp.is_long" :label="2" @change="ChangeRadio">短期住家</el-radio>
          </div>

          <h3>Agreement for International Student Homestay Program</h3>
          <div class="text">
            This agreement is made by and between Party A and Party B; whereby
            Party A agrees to pay the homestay program fee, and Party B agrees
            to provide homestay services subject to the terms and conditions as
            stipulated hereinafter：<br />
            本合同由甲乙双方签订，甲方同意支付住家项目费用，乙方同意按照以下条款提供住家服务：<br />
            Party A: 甲方<br />
            Student’s Name 学生姓名：<el-input
              v-model="ishp.student_name"
              placeholder="请输入"
              :disabled="disabledMap.ishp.student_name"
              class="student_name"
            ></el-input
            ><br />
            Student’s Date of Birth 学生出生年月日：<el-date-picker
              v-model="ishp.date_of_birth"
              type="date"
              placeholder="(mm/dd/yyyy)"
              value-format="yyyy-MM-dd"
              :disabled="disabledMap.ishp.date_of_birth"
            >
            </el-date-picker
            ><br />
            Passport ID 护照号码：<el-input
              v-model="ishp.passport_no"
              placeholder="请输入"
              :disabled="disabledMap.ishp.passport_no"
              class="student_name"
            ></el-input
            ><br />
            Party B: 乙方<br />
            Heritage Student Foundation is hereinafter referred to as HSF (a
            corporation duly organized and existing under the General
            Corporation laws of California in the U.S.) Heritage Student
            Foundation 以下简称为 HSF(HSF
            是一家根据美国加利福尼亚州通用公司法正式成立并存续的公司)<br />
            Address: 1267 Wills St. Ste 200 Redding CA 96001<br />
            地址：1267 Wills St.Ste 200 Redding CA 96001<br />
            Administration Only - Do Not Change 仅供行政使用-不可修改<br />
            Program Period -
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              placeholder="请输入"
              class="student_name"
            ></el-input>
            <div class="months" v-if="ishp.is_long == 1">months</div> <div class="months" v-if="ishp.is_long == 2">weeks</div><br />
            项目有效期 -
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              placeholder="请输入"
              class="student_name"
            ></el-input>
            个<div class="months" v-if="ishp.is_long == 1">月</div><div class="months" v-if="ishp.is_long == 2">周</div><br />
            Program Intake 学生入学季
            <el-input
              v-model="ishp.enter_season"
              :disabled="disabledMap.ishp.enter_season"
              placeholder="请输入"
              class="student_name"
            ></el-input>
          </div>

          <div class="fenge"></div>

          <h1>Section One：第一部分</h1>
          <h3>HSF SERVICE OVERVIEW HSF 服务概述</h3>
          <div class="text">
            HSF provides international students in America with a safe, high
            quality and culturally enriching host family living experience
            matched to students’ needs and preferences. The service overview is
            as follows:<br />
            HSF
            为在美国的国际学生提供安全、高质量和文化丰富的寄宿家庭生活体验，且根据学生的需求和偏好进行住家匹配。服务指南概述如下:<br />
            <div class="title">Host Family Arrangement 寄宿家庭安置</div>
            1. Host Family Matching: Collect the introduction information of
            host families and send it to students for selection; Training for
            contracted host families on how to accommodate students.<br />
            寄宿家庭匹配：搜集整理住家介绍资料发学生备选；对签约住家进行学生接待培训<br />
            2. Host Family Background Investigation<br />
            寄宿家庭背景调查<br />
            3. Host Family Communication and Replacement<br />
            寄宿家庭沟通和更换<br />
            <div class="title">
              Supervision and Other Services 在美监管和其他服务
            </div>
            4. Host Family Visits<br />
            寄宿家庭探访<br />
            5. Regular contact with the school to deal with students' issues at
            school<br />
            与学校定期沟通处理学生在校问题<br />
            6. Monthly feedback on host family and score reports<br />
            月度住家及成绩报告反馈<br />
            7. 24-hour emergency contact service<br />24小时紧急联系
            <div class="title">
              For service details, please refer to HSF Day School Service Guide
              Book <br />
              具体服务细则，请参考《HSF 走读学校后期服务细则》
            </div>
          </div>

          <div class="fenge"></div>

          <h1>Section Two:第二部分</h1>
          <h3>RESPONSIBILITIES AND OBLIGATION 责任与义务</h3>
          <div class="text">
            HSF will conduct the home-environment inspection and background
            investigation of the recommended host families and strictly filter
            them to provide a quality host family for students to choose from,
            and charge based on the services provided. The host family should
            provide a warm, harmonious, and friendly environment for students to
            live in. Students are expected to follow the rules of HSF and their
            host families, treat people politely, integrate into their new
            environment, and have a pleasant homestay life in the United States.
            <br />HSF
            将对推荐的住家进行环境检查和背景调查，严格谨慎地筛选住家，为学生提供优质的住家选择，并依据其提供的服务收取学生费用。住家应为学生提供一个温馨、和谐、友爱的
            住宿环境，学生应遵守 HSF
            和住家的入住规则，礼貌待人，以尽快融入新环境，在美国度过愉悦的住家生活。
            <div class="title">Homestay Program 住家项目</div>
            1. The homestay program includes:
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input>
            <div class="months" v-if="ishp.is_long == 1">months</div> <div class="months" v-if="ishp.is_long == 2">weeks</div> of homestay accommodation,homestay meals (one meal in the
            morning and one in the evening on weekdays, three meals on weekends
            and holidays), and international student management fees .<br />

            住宿项目包含：<el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input
            >个<div class="months" v-if="ishp.is_long == 1">月</div> <div class="months" v-if="ishp.is_long == 2">周</div> 寄宿家庭住宿费、寄宿家庭餐费(工作日早晚两餐，周末及节假日三餐)、国际学生监管费。
            <br />

            <div class="width20"></div>
            2. Contract period. The minimum program contract term is
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input>
            <div class="months" v-if="ishp.is_long == 1">months</div> <div class="months" v-if="ishp.is_long == 2">weeks</div>, except for students who will graduate within less than
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input>
            <div class="months" v-if="ishp.is_long == 1">months</div> <div class="months" v-if="ishp.is_long == 2">weeks</div>. The initial program fee does not include the summer break
            period. <br />
            合同期限：寄宿家庭合同期为期
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input>
            个<div class="months" v-if="ishp.is_long == 1">月</div> <div class="months" v-if="ishp.is_long == 2">周</div> ，除非学生将在
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input>
            个<div class="months" v-if="ishp.is_long == 1">月</div> <div class="months" v-if="ishp.is_long == 2">周</div> 之内毕业。拟定好的寄宿家庭费用不包括暑假期间费用。

            <div class="width20"></div>
            3. Extension. In the event the student extends the program beyond
            the
            <el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input
            >-<div class="months" v-if="ishp.is_long == 1">-months</div> <div class="months" v-if="ishp.is_long == 2">-weeks</div>  period, i.e., the student's returning flight at the end of
            the school year is AFTER the last day of the program, HSF will issue
            an invoice for the prorated fee that corresponds to the additional
            days of student's residence in homestay after the completion of the
            program. <br />延期：如果<el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              class="residence_time"
              placeholder="请输入"
            ></el-input
            >个<div class="months" v-if="ishp.is_long == 1">月</div> <div class="months" v-if="ishp.is_long == 2">周</div> 项目期限已满，学生因为各种原因需要留住寄宿家庭(例如学生的回国航班起飞日期在项目截至日期之后)，HSF
            会根据学生具体留宿的天数来计算学生延期入住的费用，并开具相应的费用账单。

            <div class="width20"></div>

            4. Payment of Program Fee. Students must pay the corresponding
            homestay fee to HSF by wire transfer within the specified time.
            <br />
            项目费的支付：学生须在规定时间内，向 HSF 支付相应的寄宿家庭费用。<br />
            If the student decides to remain at the Host Family's residence over
            summer break rather than returning to his/her home country, an extra
            fee, including but not limited to the homestay fee and management
            fee, has to be remitted to HSF for the summer period, because the
            Host Family will need to spend more time and effort to accommodate
            and support the student. The student must pay the program fee for
            the extended period (Sixty) days prior to the end of the semester
            before summer break starts.<br />
            如果学生选择暑假期间继续居住在寄宿家庭，须向
            HSF支付额外费用，此费用包括但不限于寄宿家庭费和管理费。因为在暑假期间，寄宿家庭将会花费更多的时间和资源用来照顾学生。如果学生需要在暑假留住寄宿家庭，学生必须在学期结束前
            60 天支付额外的寄宿家庭费用。
            <div class="width20"></div>

            5. Payment of Other Expenses. Students' personal expenses and
            expenses for School are not included in the program fee. HSF is not
            obligated to manage the Student's personal financial affairs, such
            as lunch fees or extra school expenses.<br />
            其他费用的支付：学生个人消费和在校期间的花销不包括在项目费用里。HSF
            无义务管理学生的个人财务事宜，诸如午餐费或者额外的学校支出费用。<br />
            <div class="width20"></div>
            6. School Tuition and Fees. School Tuition and Fees are collected
            and paid by HSF on behalf of the school. School Tuition and Fees
            include, but are not limited to, registration fee, I-20 fee, tuition
            insurance plan (the student is advised to purchase if available),
            tuition, miscellaneous fees, international student fee, school bus
            fee, school lunch fee, activity and facility fee, school uniform
            fee, etc. <br />
            学校费用：学校费用是由 HSF 代收代缴，包括但不限于注册费、I-20
            费、学费保险(如果学校提供，建议学生购买)、学费、学杂费、国际学生费、校车费、午餐费、活动设施费、校服费等。<br />
            <div class="width20"></div>
            7. Refund agreement. After the parent or the student makes the
            payment of the HSF program fees, if the student voluntarily
            withdraws from the HSF program, HSF will not refund any fees. If the
            student is suspended or expelled from the school due to
            non-compliance with the school rules, HSF will not refund any fees.
            <br />
            退费协议：家长或学生一旦缴纳 HSF 项目费用后，学生如自愿从 HSF
            项目中退出，HSF
            将不退还任何费用；如学生入读后，因不遵守学校的校规，被学校责令停学或开除，HSF
            将不退还任何费用。
            <div class="width20"></div>
            8. School Guardian. The Student's Parent(s) agrees to appoint the
            assigned Host as the school guardian of the Student during the
            Student's stay in the Host's residence. The Host takes the role of
            the Student's Parent for all school matters, such as participating
            in parent/teacher's conferences, signing permission slips, parental
            participation in school events, etc.<br />
            学校监护人：在学生住在寄宿家庭期间，学生家长同意指派相应的寄宿家长作为学生在校期间的学校监护人。在一切学校事务中，寄宿家长应充当学生家长的角色，例如参加家长会、签署同意书，以及参加任何要求家长出席的学校活动等。
            <div class="width20"></div>
            9. Host Parents Obligations. HSF will clearly state the necessary
            responsibilities of hosting to the homestay host. If the Host does
            not fulfill all necessary obligations required to provide a proper
            homestay environment, after the start of the homestay, HSF, to the
            best of its ability, will find an alternate Host for Student. If the
            Student is hospitalized, the Host is not responsible for providing
            care to the Student at the hospital. Instead, Student's Parent(s)
            must come to the U.S. to care for their child if necessary. <br />
            寄宿家长责任：HSF将会和寄宿家庭明确其必须具备的寄宿家庭责任。如果寄宿家长没有履行责任，不能营造恰当的寄宿家庭环境，HSF
            会全力为学生替换寄宿家庭。如果学生因病住院治疗，寄宿家长没有在医院照顾学生的责任。如有需要，将由学生父母来美国照顾自己的孩子。
            <div class="width20"></div>

            10. Fully Furnished Room. The host provides Student a furnished room
            including a desk, desk light, chair, bed, bed sheets, blankets, and
            a closet. The host shall provide clean sheets for the bed during
            Student' s stay. Host shall allow the Student to use laundry
            machines as well. The room is available only to the Student for the
            entire period of the academic year (<el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              placeholder="请输入"
              class="residence_time"
            ></el-input>
            <div class="months" v-if="ishp.is_long == 1">months</div> <div class="months" v-if="ishp.is_long == 2">weeks</div> ). Thus, if the Student leaves personal belongings during the
            summer break when school is not in session, the Student will incur a
            summer storage fee, the amount of payment shall be required by the
            Host family, until the Student's return in the fall. In the case
            that Host is not capable of storing Student's personal belongings,
            the Student shall contract with a storage company with the
            assistance of HSF to store the Student's belongings until the
            Student's return.
            <br />配套齐全的房间：寄宿家庭提供给学生家具齐全的房间，包括书桌，台灯，椅子，床，床单被褥和衣橱。寄宿家庭在学生留宿的时候会提供干净的床单。寄宿家庭允许学生使用洗衣
            机。在一整个学年(<el-input
              v-model="ishp.validity_period"
              :disabled="disabledMap.ishp.validity_period"
              placeholder="请输入"
              class="residence_time"
            ></el-input>
            个<div class="months" v-if="ishp.is_long == 1">月</div> <div class="months" v-if="ishp.is_long == 2">周</div> )的时间内，该房间供学生一人使用。在学校暑假休课时间，如果
            学生把个人物品寄存在房间内，学生需要根据住家要求支付住家寄存费。如果寄宿家庭无法
            存放学生物品，学生必须通过 HSF
            联系物品存放服务公司来存放他们的个人物品直到学生返回，相应费用将由学生自行负责。
            <br />
            Host must sustain a comfortable temperature in the Student's room
            while the Student is in the house. Student may request host to
            increase or decrease temperature only if deemed reasonable.<br />
            住家必须将学生房间里的温度维持在舒适的状态。只有在被认为合理的情况下，学生才能
            要求住家升高或降低温度。<br />
            Host allows the Student to use laundry machines. Host provides
            laundry detergent with instructions on how to operate the washer and
            dryer. If Host's home uses shared, coin-operated laundry facilities
            with other units (such as in a condominium or apartment complex),
            the Student needs to pay for the own laundry costs.
            <br />
            住家允许学生使用洗衣机。住家为学生提供洗衣粉及如何操作洗衣机和烘干机的说明。如果寄宿家庭与其他单元楼（如公寓或公寓楼）共用投币式洗衣设施，学生需要自行支付洗衣费用。
            <div class="width20"></div>
            11. Meals. The Host provides breakfast and dinner on weekdays and
            three meals on weekends. Lunch must be purchased at the school
            cafeteria or be ordered according to school arrangements. In the
            event the Student misses a meal due to tardiness, oversleeping,
            etc., the Host is not obligated to prepare an additional meal. The
            Student is not permitted to eat meals or snacks in the bedroom
            unless the Host provides explicit permission otherwise.
            <br />膳食：寄宿家庭在工作日提供早餐和晚餐，在休息日提供三餐。午餐根据学校安排购买。如果学生因个人原因，例如拖沓，睡过头等等而错过用餐时间，寄宿家庭无义务为学生另外准备餐点。在寄宿家庭允许下，学生可以在卧室进食餐点或零食。

            <div class="width20"></div>

            <el-form
              ref="form1"
              label-width="120px"
              v-if="!this.$route.query.type"
            >
              <el-form-item label="12.是否需要接送">
                <el-select
                  v-model="ishp.is_need"
                  placeholder="是否需要住家接送"
                >
                  <el-option label="需要" value="0"></el-option>
                  <el-option label="不需要" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!--  -->
            <!-- 需要切换 -->
            <div class="div" v-if="ishp.is_need == 0">
              12. Transportation. The host family provides a shuttle service to
              and from school Monday to Friday. If students participate in club
              activities or other activities resulting in changes in school
              time, they need to communicate with the host in advance. If the
              school time cannot be picked up due to the temporary change of
              students' school time, the Students need to choose public
              transportation to home by themselves. Additional transfers are
              required during holidays and students are required to pay the host
              family a fee based on the actual distance and time spent.
              Communicate time and schedule with the host in advance. The
              airport transfer service includes
              <el-input
                v-model="ishp.transfer_count"
                :disabled="disabledMap.ishp.transfer_count"
                placeholder="请输入"
                class="residence_time"
              ></el-input>
              times in one school year. You need to confirm the airport and
              pick-up time with your home before purchasing the ticket.
              <br />交通工具：寄宿家庭为学生提供周一到周五上下学接送服务。如学生因参加社团活动或其他活动导致放学时间变化，需和住家提前沟通时间。如因临时变动放学时间无法提供接送，学生需要自行选择公共交通工具回家。节假日学生需要额外接送，学生需要根据实际距离和花费的时间向寄宿家庭支付相应的费用。需提前与住家沟通时间和行程。接送机服务包含一
              学年<el-input
                v-model="ishp.transfer_count"
                :disabled="disabledMap.ishp.transfer_count"
                class="residence_time"
                placeholder="请输入"
              ></el-input
              >次，购买机票前需和住家确认接送机机场以及接送时间后再购买机票。
            </div>

            <div class="div" v-if="ishp.is_need == 1">
              12.Transportation: Students take the school bus to and from school
              Monday to Friday. If the school time changes due to participating
              in club activities or other activities, students need to inform
              the host family in advance. Additional transfers are required
              during holidays and students are required to pay the host family a
              fee based on the actual distance and time spent. Communicate time
              and schedule with the host in advance. The airport transfer
              service includes
              <el-input
                v-model="ishp.transfer_count"
                :disabled="disabledMap.ishp.transfer_count"
                placeholder="请输入"
                class="residence_time"
              ></el-input>
              times in one school year. You need to confirm the airport and
              pick-up time with your home before purchasing the ticket.
              <br />交通工具:
              学生自行乘坐校车上下学。如学生因参加社团活动或其他活动导致放学时间变化，需和住家提前告知时间。节假日学生需要额外接送，学生需要根据实际距离和花费的时间向寄宿家庭支付相应的费用。需提前与住家沟通时间和行程。接送机服务包含一学年<el-input
                v-model="ishp.transfer_count"
                :disabled="disabledMap.ishp.transfer_count"
                class="residence_time"
                placeholder="请输入"
              ></el-input
              >次, 买机票前需和住家确认接送机机场以及接送时间后再购买机票。
            </div>
            <!-- 需要切换 -->
            <div class="width20"></div>
            13. Change of Host Family: All changes or renewals of host families must be arranged through HSF. If a student is dissatisfied with their host family, or if the host family determines that the student's behavior violates the household rules, either party may apply for a change. A student is permitted to change host families up to two times within a one-year contract period. HSF will verify the student's circumstances and determine the necessity of a host family change prior to proceeding with any arrangements. Should a student need to change host families, they must provide the host family with at least 60 days' advance notice. Failure to provide this 60-day advance notice will result in the student being liable for compensation equivalent to two months of host family and supervision fees.
            <br />更换寄宿家庭:更换或者续费寄宿家庭都必须通过 HSF进行。如果学生对寄宿家庭不满，或者寄宿家庭认为学生行为违反住家规定，双方都可以申请更换。学生在一年合同期限内可以更换两次寄宿家庭。HSF 将在更换住家前核实学生的情况并且判断是否有更换寄宿家庭的必要。学生如需更换住家，必须至少提前 60天通知住家，未提前60天通知住家，需赔偿两个月寄宿家庭和监管费用。
            <div class="width20"></div>
            14. Parental Visitation. The Host is not responsible for or
            obligated to provide housing or transportation to Student's
            parent(s) to the United States during their visitation. Parent(s)
            must arrange accommodations at the nearest hotel or family
            residence. Student's parent(s) who visit during the school year must
            notify HSF (Thirty) days before the visitation date. Student's
            parent(s) cannot stay at the Student's homestay without the
            permission of HSF. HSF may provide assistance with hotel
            arrangements.<br />
            父母拜访：学生父母需自行负责其赴美探访孩子期间的住宿或交通。学生父母必须在住家附近酒店或者住宅区自行安排住宿。学生父母赴美探视前，须提前
            30 天通知 HSF，未经HSF 允许，不可擅自入住学生的寄宿家庭。HSF
            可以协助学生父母安排酒店住宿。

            <div class="title">Student Rules and Regulations 学生守则</div>
            <div class="width20"></div>
            15. Invitation of Friends. The Student is only allowed to invite
            friends to the Host's home if the Host is notified in advance and
            approval is obtained from the Host. The Student's friend(s) must
            abide by all house rules set by the Host. <br />
            邀请朋友：除非得到寄宿家长许可，学生不可随意邀请朋友到寄宿家庭且留宿。学生的朋友必须遵从所有寄宿家庭的规则。
            <div class="width20"></div>
            16. Sleepover/Trip Permission. The Student will not be allowed to
            sleep over at a friend's house or elsewhere unless Student's parent
            completes and submits a "Sleepover/Trip Permission Form”.<br />
            在外过夜/旅行许可：学生不得在朋友家或其他任何地方过夜，除非学生父母同意并提交“过夜允许同意书”。
            <div class="width20"></div>
            17. Internet. Students must have his/her own laptop computer in
            order to conduct schoolwork. The Student is prohibited from using
            the Host's computer. Homestay houses will provide high- speed
            internet in the form of DSL or Cable connection. The Host may set an
            internet usage rule to prevent Student's internet addiction. If
            continued usage of laptop computers leads to addiction or problems
            such as oversleeping, non socialization, poor relations with the
            Host or drop in grades, HSF and Host will set a schedule for the
            Student to turn in his/her laptop computer to the Host.<br />
            网络：学生必须拥有属于自己的笔记本电脑以完成学校作业。学生不得使用寄宿家庭的电脑。寄宿家庭会提供高速的
            DSL
            或者Cable网络。寄宿家庭会有防止学生网络成瘾的网络使用规则。如果因为持续使用笔记本电脑导致网络成瘾或者以下问题，诸如睡过头、缺乏社交、跟寄宿家庭关系生疏、学习成绩下降，HSF和寄宿家长会制定一个时间表来限制学生使用笔记本电脑的时长。
            <div class="width20"></div>
            18. Additional International Students. The Student is NOT allowed to
            initiate homestay arrangements for additional international students
            without first contacting and informing HSF of all details.
            Additional Student(s) must apply and work through HSF in order to
            reside with an HSF host family. In the event Student does not inform
            HSF of additional international Student(s) who reside with an HSF
            host family through the Student's own arrangement, the Student may
            jeopardize his/her current homestay arrangement. <br />
            其他国际学生：未得到HSF的许可，学生不得私自为其他国际学生安排寄宿家庭。其他国际学生必须通过HSF申请，方可住在
            HSF的寄宿家庭里。如果学生不通知HSF，帮助其他国际学生住在寄宿家庭里，HSF有权将学生开除其国际生住家项目。
            <div class="width20"></div>
            19. Rules of communication with host families. After paying the full
            amount of program fee, if students have any questions related to
            their stay, they can communicate with the Host via Zoom, arranged by
            HSF. Student party is PROHlBITED from approaching Host to bypass HSF
            and direct communication with Host to negotiate the renewal or
            adjustment of program terms is STRlCTLY prohibited. In case of any
            breach, HSF reserves the right to expel the student from the
            International Residential program and hold him/her accountable.
            <br />与寄宿家庭的沟通：学生在缴纳全款后，如有入住相关的问题，可在
            HSF
            安排下与住家进行远程视频沟通。学生方严禁越过HSF，直接跟寄宿家庭协商续签或更改项目合约。如有违背，HSF
            有权将学生开除其国际生住家项目并追究其相关责任。
            <div class="width20"></div>
            20. Student Etiquette and House Rules. Student must follow the rules
            and regulations set by HSF, the host family and the school.
            <br />学生礼仪和寄宿家庭规则：学生必须遵守
            HSF、寄宿家庭及学校的规定。<br />
            a. Student must abide by host family's rules if the rule is commonly
            reasonable and fully explained when student moves in. HSF recommends
            the host to inform the student of any family rules during the first
            two weeks after the Student's arrival.<br />
            寄宿家庭在学生入住时提出并详细解释合理的寄宿家庭家规，学生须遵守。HSF
            建议寄宿家庭家长在学生到达 2 周以内跟学生说明家规。
            <br />b. Student must show respect towards teachers and host
            family.<br />
            学生必须尊重老师和寄宿家庭成员。 <br />c. Student should attempt to
            use the English language as much as possible during the program.
            <br />在寄宿家庭项目中，学生应尽可能多地使用英语交流。<br />
            d. HSF will abide by the policies set by the school in attendance by
            Student. Student must respect the host family's private affairs.
            <br />HSF 将遵守学生所在学校的一切规定。学生必须尊重寄宿家庭的隐私。
            <br />e. During the homestay program, students are prohibited from
            installing cameras in the homestay.
            <br />在寄宿家庭项目中，学生禁止在住家安装摄像头。
            <div class="width20"></div>
            21. Health and Hygiene. If Student falls ill and is rendered
            incapable of attending school that day, Student must inform the host
            so that an excused absence can be reported to the school. Student
            should not attend school when they have any of the following
            symptoms: diarrhea, fever, vomiting. Furthermore, daily routines in
            good hygiene can prevent the spread of disease and infection.
            Student must observe these practices.<br />
            健康与卫生：如果学生因病而无法上学，学生须及时通知寄宿家长，以便及时向学校报告病假。当出现腹泻、发烧、呕吐等情况时，学生应在家休息。另外，学生在日常生活中保持良好的卫生习惯有助于预防疾病传播。
            <div class="width20"></div>
            22. Home & Furniture Damages and Uncleanness. Student's room will be
            inspected before the student has moved out of the room and home. If
            the host claims of any reasonable damages found to their home and
            property, or that the room has been kept in a dirty manner, the
            compensation will be paid by the Student if the complaint is
            reasonable.<br />
            家具、家居用品的污损和赔偿：学生搬出寄宿家庭之前，HSF
            会检查其使用过的房间。如果寄宿家庭就家中财物、财产的损坏，或房间卫生状况过差而提出申诉，若申诉合理，学生则需支付相应的赔偿。

            <div class="width20"></div>

            23. Student's Employment. Student is strictly prohibited from being
            employed while enrolled in HSF 's International Student Homestay
            Program. <br />
            学生打工：在参加 HSF 项目期间，学生严禁打工。
            <div class="width20"></div>
            24. Misconduct, Actions, or Conditions Leading to Termination. The
            actions and behaviors listed below may lead to the termination of
            the program agreement by HSF. HSF will assess each situation and
            determine if Student will be placed on probation or terminated from
            the homestay program.<br />
            可导致合同终止的不当行为：如学生出现以下行为，HSF
            会终止项目合同。HSF 会评估
            每个具体个案并决议是否将学生转为留用查看状态，或直接终止其参与的住家项目。<br />
            a. Smoking/Drinking/Use of Illegal Substances: Consumption or
            possession of alcoholic beverages as well as the use or possession
            of any type of illegal drug or tobacco on school property or host's
            residence is strictly prohibited. Illegal actions, made by Student,
            will be assessed by HSF.<br />
            吸烟/喝酒/使用违禁药品：学生严禁在学校或寄宿家庭饮用、食用或持有含酒精类饮
            料、烟草、违禁药物等。学生的违法行为将由 HSF 评定。<br />
            b. Leaving Host's residence without notification: The Student will
            not be allowed to sleep over or have short or long trip without
            approval. To ensure the personal safety of the student, the host
            family has the right to know where the student is at any time. If
            the student will not return host home at night or go on long trips,
            he/she needs to have their parent(s) sign the Liability Release to
            Leave Host's Residence for going out. If the parent(s) refuse to
            sign the Liability Release to Leave Host's Residence after being
            notified by the HSF personnel, any accidents or disputes that occur
            after the student leaves his/her host home are not the
            responsibility of HSF. If the student needs to leave their host home
            or have a sleep over, the parent(s)/guardian must inform HSF 24
            hours in advance. The student also needs to inform his/her host
            family 24 hours in advance. If he/she leaves his/her host home or
            have a sleep over without notifying his/her host home and HSF in
            advance, any accidents or disputes that occur after the student
            leaves his/her host home are not the responsibility of HSF.
            <br />
            在未经许可的前提下,学生不可自行外出进行短途或长途旅行。为保障学生人身安全，寄宿家庭有权随时知晓学生身处何处。学生如夜不归宿、远行等需要家长签署外出授权及免责协议，在
            HSF
            工作人员告知后，如家长拒绝签署，学生离开住家后产生任何意外及纠纷与
            HSF无关。 学生若需要离开住家或夜不归宿，需家长或监护人提前 24
            小时告知 HSF,学生也需提前 24小时告知住家，如未提前通知住家和 HSF
            的情况下离开住家或者夜不归宿后，产生的任何意外及纠纷与 HSF无关。<br />
            c. Unapproved School Absence: Any absence attributed to reasons of
            an unexceptional nature must be pre-discussed with the homestay host
            and the school in attendance. Extended vacation days during the
            school year leading to multiple missed school days must be approved
            by the school and the host.
            <br />未经允许的缺勤：任何非特殊原因造成的缺课，学生应提前告知寄宿家庭和学校，并得到寄宿家庭和学校的许可。在学年内，学生因需要延长假期而导致的多次缺勤，必须经学校和寄宿家长同意。<br />
            d. Verbal or Physical Violence: In the event that Student becomes
            verbally or physically violent towards fellow classmates, teachers,
            school officials, host, and members of a host family, pets are given
            family member status as well—HSF will investigate each situation and
            determine if the consequence will be termination of the program
            agreement. Violence towards oneself, or self-injury, can also lead
            to immediate termination. The student will be held responsible for
            all necessary expenses, including attorney fees, HSF coordination
            fees, transportation fees, etc.<br />
            语言或身体暴力：如学生对学校同学、老师、教职员工、寄宿家庭主人、寄宿家庭成员(寄宿家庭宠物也属于其家庭成员)等行使语言或身体暴力，HSF
            将有权调查每一个具体情
            境来决定是否终止寄宿家庭项目协议。对自己使用暴力和自我伤害等行为也可能导致协议被立即终止。因学生语言或身体暴力而产生的任何费用，包括律师费、HSF
            协调费、交通费等，全部由学生一方承担。<br />
            e. Weapons: Student shall not possess or use a weapon-loaded or
            unloaded even those that are in the host's home and registered.
            Everyday objects and tools are considered potential ‘weapons’ as
            well, depending on its use and the user's intent. Devices and
            instruments having the appearance of a weapon are also strictly
            prohibited, including look-a like guns, toy guns, and any object
            that is a facsimile of a real weapon.<br />
            武器：学生不得持有或使用武器(包括装弹或者未装弹)，即使武器属于寄宿家庭并且是已注册的。依据使用方法和使用者的意图，日常物品和工具也被视为潜在“武器”。同时，
            学生严禁使用外形类似武器的设备和仪器，包括形似枪的物品、玩具枪、以及任何类似真正武器的仿制品。<br />
            f. Medical Conditions: Actions leading to either Student's own or
            another's medical condition that disrupts the academic environment
            or homestay may lead to termination. HSF will evaluate the
            circumstances surrounding the medical condition. It is the sole
            discretion of HSF as to whether or not the student is eligible to
            continue participating in the homestay.<br />
            健康状况：如学生因自身健康状况或其他原因导致的疾病等而影响学习或妨碍寄宿生活，HSF
            可能会终止寄宿家庭项目协议。由 HSF 评估具体的医疗状况，且 HSF
            对学生是 否有资格继续参加寄宿家庭项目拥有最终决定权。
            <div class="width20"></div>
            25. Emergency and Medical Insurance. Host may provide Student with
            assistance in emergency situations. New students must purchase
            insurance policy covering the period of their stay in the U. S. in a
            given school year from the insurance provider designated by HSF.
            Transfer students must have his/her own medical insurance to cover
            the Entire program period. Proof of proper insurance must be
            submitted to HSF prior to the move-in date. HSF and Host family have
            no obligations to pay for the Student’s medical bills. Host may sign
            any urgent and necessary forms in emergency room at hospital to take
            necessary actions to preserve Student's health and well-being.
            Furthermore, if additional immunizations or vaccinations are
            required by the school, the host will authorize permission to allow
            Student to fulfill requirements of the state law. All remaining
            medical/hospital expense balances after insurance coverage must be
            paid by Student's parent(s).<br />
            紧急情况和医疗保险：寄宿家庭主人会在紧急情况下为学生提供援助。新学生必须在
            HSF
            指定的保险机构购买医疗保险，且保险期须覆盖学生一学年内在美国居留的时长。转学生必须购买覆盖整个住家项目时长的医疗保险。学生入住前须向
            HSF 提供适合的保险凭证。HSF
            和寄宿家庭均无义务为学生支付医疗费用。在紧急情况下，为保证学生的健康和生命安全，寄宿家长可以在医院急诊室签署紧急或必要的文件。另外，如果学校额外要求学生接受免疫和疫苗项目，寄宿家长将根据所在州的相关法律提供相应授权。在医疗保险覆盖范围之外的医疗/医院花费均须由学生家长承担。
            <div class="width20"></div>
            26. Accidents. Unforeseen circumstances can lead to accidents
            involving the Student, such as car accidents or physical injury. The
            coordination process to resolve issues involving third parties such
            as an insurance company may be conducted by HSF upon the request of
            the Student's parent(s) or guardian. The Student shall be
            responsible for an additional fee for such duties.
            <br />意外事件：不可控因素可能导致学生遭遇事故，如车祸和人身伤害等。处理这类问题而涉及的协调工作可能会涉及第三方，例如保险公司等。根据学生父母或监护人的要求，HSF会与这些机构协调。由此产生的额外的费用将由学生方承担。
            <div class="width20"></div>
            27. Student's Driving. Student must NOT drive any type of motor
            vehicle, unless ALL, the following conditions are met.
            <br />驾驶：学生不得驾驶任何机动车辆，除非满足以下所有条件：<br />
            Student is over 18 years of age and has a U.S. issued driver's
            license.<br />
            学生已年满 18 岁，并持有美国驾驶执照。<br />
            Due to the weak traffic safety awareness and lack of driving
            experience among minors, in order to protect their personal safety,
            if this situation is not met, students are not allowed to drive, and
            any accidents that occur are not related to HSF.<br />
            因未成年人交通安全意识不强以及驾驶经验不丰富，为保护未成年人人身安全，如未满足此情况，学生不得开车，且产生的一切意外与
            HSF 无关。
            <div class="width20"></div>
            28. Consent to Photo Release. Student and his/her parent(s) or legal
            guardian give consent to HSF the use of any photo containing the
            student for any publications and marketing in order to enrich the
            nature of the program. Such photos may include photos with host
            family, school activities, trips, and etc.
            <br />同意使用照片：学生方同意
            HSF在出版物和营销媒体上使用学生照片，包括与寄宿家庭在一起时的情景，学校活动、旅行时拍摄的照片等等。
            <div class="width20"></div>
            29. Indemnification. Student's parent(s) or legal guardian agrees to
            indemnify and hold harmless HSF, Inc. and/or
            its29.Indemnification.employees, from any and all claims, actions,
            suits, proceedings, costs, expenses, damages, and liabilities,
            including attorney's fees arising out of, connected with or
            resulting from the Student's participation in the HSF program,
            including but not limited to accepting Student's stay in Host's
            house. <br />
            豁免条款：学生参与HSF的项目期间(不仅只限于学生住在寄宿家庭期间)所造成或产生的相关索赔行为、诉讼、程序、费用、损失、负债、已发生的律师费等事项，概不属于HSF及其工作人员的责任，学生家长或法定监护人同意豁免
            HSF 以上所有责任。
            <div class="width20"></div>
            30. Student should obey every country’s own laws and acceptable
            codes of conduct, which include standards of behavior from dress,
            etiquette, morality, politics, etc. And he/she recognizes that
            actions that violate these laws or standards may harm the interests
            of the homestay in which his/her lives, as well as his/her own
            health and safety.<br />
            学生应该遵守每个国家的法律和可接受的行为准则，包括着装、礼仪、道德、政治等行为，并认识到，违反这些法律或行为标准可能会损害所在住家的利益，以及学生自己的健康和安全。
            <div class="width20"></div>
            31. Student should obey the rules, standards, and behavioral
            guidelines of HSF and the host family. Student's parent(s) need to
            take risks arising from Student's violation of laws and codes of
            conduct. If Student violates the laws and codes of conduct of the
            United States, Student's parent(s) need to waive and release all
            claims and liabilities against HSF and its host family. In the event
            of force majeure (such as earthquakes, epidemics, warfare and school
            closures)and personal accidental injury, and all the harm caused by
            psychological problems,etc. Student and the parent(s), agree to
            waive and release all claims and liabilities against the host family
            and HSF, but HSF will assist Student and the parent(s) to deal with
            the corresponding problem.<br />
            学生应该遵守 HSF
            和寄宿家庭的规则、标准和行为指导，并且学生家长需要承担由于学及其寄宿家庭的所有索赔和责任。学生如遇到不可抗力的因素(包括但不限于地震、疫情、战争以及学校倒闭等)以及人身意外伤害和心理问题产生的一切伤害等情况，学生和家长免除住家和
            HSF的一切责任，但HSF将协助学生和家长处理相应问题。<br />
            “I certify that I have read, reviewed carefully, and consent to all
            that is stated above.”<br />
            “兹证明我已仔细阅读、评估并同意上述规定”
          </div>

          <el-form class="demo-ruleForm">
            <div class="person flex-sb">
              <el-form-item label="Signature of Parent/Guardian 家长签名:">
                <vue-esign
                  ref="ishp"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="ishpReset" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 家长姓名打印:">
                  <el-input
                    v-model="ishp.parent_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="ishp.parent_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="width20"></div>
            <h4 style="width: 96%; font-size: 14px; margin: 0 auto">
              If the Student is 18 years of age or over on the date of signing,
              then the Student’s signature is required.
              <br />如果签字时，学生已满 18 岁或 18 岁以上，该生也必须签字。
            </h4>
            <div class="width20"></div>
            <div class="person flex-sb">
              <el-form-item label="Signature of Student 学生姓名签字:">
                <vue-esign
                  ref="ishp1"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="ishpReset1" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 学生姓名打印:">
                  <el-input
                    v-model="ishp.student_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="ishp.student_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div class="fenge" v-if="Message.page_one && agreementType === '2'"></div>
        <homestay-agreement-c
          v-if="Message.page_one && agreementType === '1'"
          ref="ishpC"
          :ishp="ishp"
          :disabled-map="disabledMap.ishp"
          :show-transport-selector="!$route.query.type"
          editable
        />
        <div class="fenge" v-if="Message.page_one && agreementType === '1'"></div>
        <!-- Permission for Guardian Power and Medical Care -->
        <div class="Permission" v-if="Message.page_two">
          <h1>Permission for Guardian Power and Medical Care</h1>
          <h3>监护人授权和医疗授权同意书</h3>
          <div class="text">
            We are
            <el-input
              v-model="medicine.medicine_en_guardian"
              :disabled="disabledMap.medicine.medicine_en_guardian"
              placeholder="please enter"
              class="infomation"
            ></el-input>
            , parents/legal guardians of applicant
            <el-input
              v-model="medicine.medicine_en_student_name"
              :disabled="disabledMap.medicine.medicine_en_student_name"
              placeholder="please enter"
              class="infomation"
            ></el-input
            >, agree
            <el-input
              v-model="medicine.medicine_en_live_name"
              :disabled="disabledMap.medicine.medicine_en_live_name"
              placeholder="please enter"
              class="infomation"
            ></el-input
            >to have full custody of our child’s life, and allow him/her to act
            as the agent of my child, exercise the following actions or matters
            on our behalf during the homestay program period with Heritage
            Student Foundation (hereinafter referred to as HSF): 我们是
            <el-input
              v-model="medicine.medicine_guardian"
              :disabled="disabledMap.medicine.medicine_guardian"
              placeholder="please enter"
              class="infomation"
            ></el-input
            >作为申请人
            <el-input
              v-model="medicine.medicine_student_name"
              :disabled="disabledMap.medicine.medicine_student_name"
              placeholder="please enter"
              class="infomation"
            ></el-input
            >的父母或法定监护人，在学生加入 Heritage Student Foundation
            (以下简称 HSF)项目期间，寄宿家庭
            <el-input
              v-model="medicine.medicine_live_name"
              :disabled="disabledMap.medicine.medicine_live_name"
              placeholder="please enter"
              class="infomation"
            ></el-input>
            ，对学生有完全的生活监护权, 作为我孩子的代理人,
            并以我的名义代表我行使以下行为或事情 :
            <div class="width20"></div>
            1. Take on the temporary custody of my child in the United States;
            Fulfill the guardianship obligations for my child on behalf of the
            parents, and take all necessary measures to ensure the health,
            education and welfare of my child, including registering and
            enrolling my child in educational and recreational programs; Ensure
            a reasonable standard of living, including but not limited to
            accommodation, food, medical care, recreational activities and other
            daily matters.<br />承担我孩子在美的临时监护权；代替父母对我孩子履行监护义务，采取一切必要措施以保证我的孩子的健康、教育和福利，包括为我的孩子在教育和娱乐项目中注册与登记；保证合理的生活标准，包括但不仅限于住所、食物、医疗、娱乐活动和其他日常事宜；
            <div class="width20"></div>
            2. In the event of any emergency, accident or illness, act on our
            behalf to ensure the safety and interests of the student. This
            includes authorizing any qualified medical personnel to carry out
            any emergency or non-emergency medical care they deem necessary and
            appropriate until contact is made with us. It should be noted that
            if any specific diagnosis, treatment or hospitalization is required,
            any and all medical care expenses arising therefrom shall be paid by
            the parents.<br />在发生任何紧急情况、事故或疾病时，代表我们采取行动，以确保学生的安全和利益。包括授权任何由合格的医务人员进行其认为必要和适当的任何紧急或非紧急的医疗护理，直到和我们取得联系。需要了解的是，如果需要进行任何具体的诊断、治疗或住院治疗，由此产生的任何、所有的医疗护理费用由父母支付；
            <div class="width20"></div>
            3. Upon being informed and consented, during the program period the
            student is in, we agree and authorize the Heritage Student
            Foundation (hereinafter referred to as HSF) and its institutional
            personnel to sign the documents required by the student during the
            registration, enrollment and class allocation processes on our
            behalf. Including but not limited to the student application form,
            the off-campus activity permit form and the emergency contact
            information form.<br />在被告知和同意的情况下，在学生所在的项目期间，我们同意并授权
            Heritage Student Foundation
            (以下简称HSF)及其机构人员可以代表我们签署学生在注册、入学和班级分配过程中所需的文件，包括但不限于学生报名表、校外活动许可表和紧急联系信息表。
            <div class="width20"></div>
            The Guardian Power of Attorney and Permission for Medical Care shall
            be effective from
            <el-date-picker
              v-model="medicine.medicine_time"
              :disabled="disabledMap.medicine.medicine_time"
              type="daterange"
              range-separator="TO"
              start-placeholder="start"
              end-placeholder="end"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <div class="width20"></div>
            该监护人授权和医疗授权同意书生效时间为
            <el-date-picker
              v-model="medicine.medicine_time"
              :disabled="disabledMap.medicine.medicine_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <div class="width20"></div>
            <div class="title">
              Health and Accident Insurance 健康和意外保险
            </div>
            I further agree to bear full responsibility for any and all medical
            expenses incurred during treatment that are not covered by the
            medical insurance policy.<br />
            我同意持续支付我孩子的医疗和意外保险费用。我进一步同意支付在治疗中产生的经学校批准但在医疗保险责任以外的任何及全部花费。<br />
            <div class="title">Other Provisions 其他规定</div>
            This Authorization is intended by me to be valid in any jurisdiction
            in which it is presented. The various powers granted herein are
            separate and severable to the effect that the possible invalidity of
            any one or more of such powers shall not affect the validity of any
            other powers.<br />
            此授权书根据我的意愿发起，在其所示的任何司法辖区内有效。此处授予的多项权力相互独立且可分割，其中任何一项权力失效并不影响其他各项权力的效力。<br />
            This Authorization is written in the English language. In case of
            discrepancies between the English text version of this Authorization
            and any translation, the English version shall prevail. All pronouns
            and any variation thereof refer to the masculine, feminine or
            neuter, singular or plural, as the identity of the person or persons
            may require.<br />
            该授权书用英文书写。如果在该授权同意书的英文版本与其他翻译版本有差异时，以英文版本为准。根据个人或某些人身份的需要，所有的代词和任何其他变化形式，特指男性，女性或中性，单数或者复数。<br />
            Photocopies of this Authorization shall have the same force and
            effect as the original. I authorize the Custodian and the School to
            share copies of this Authorization with the host family or
            residential services provider, HSF Network and its boards,
            commissions, committees, employees, officers, directors, servants,
            agents, and assigns.<br />
            该授权书复印件应具有与原件相同的效力。我授权代理人和学校可以与住宿家庭或住宿服务提供方，HSF及其董事会，委员会，常设委员会，雇员，管理人员，董事，服务人员，代理和受让人共享此授权书。<br />
            The validity and interpretation of this Authorization shall be
            governed by the laws of the State where the School is located,
            without regard to its choice of law provisions or the choice of law
            provisions of other jurisdictions.
            <br />此授权书之有效性和解释受学校所在州法支配，不管其选择适用何条法律条款或选择适用其他司法系统法律条款。<br />
            It is understood that this Authorization is given in advance of
            custody of my child and any such medical treatment and is given to
            provide authority and power on the part of the Custodian in the
            exercise of his or her best judgment.
            <br />我理解该授权书将在我孩子的监护赋予以及任何治疗之前提供，并且为代理人提供在行使他/她最佳判断时的授权和权力.<br />
            Once this Designation Sheet has been completed, it will be attached
            to all documents that reference a Designation Sheet and a copy shall
            be provided to the host family or residential provider. Furthermore,
            HSF reserve the right to modify, change, or exchange the individuals
            listed on this sheet at any time.
            <br />一旦完成此指定委托书，此委托书必须附在所有提及指定委托的文档，并且提供复印件给住宿家庭或住宿提供机构。此外
            HSF 留随时修改、更改或调换此委托书上所列人员的权力。
          </div>

          <el-form class="demo-ruleForm">
            <div class="person flex-sb">
              <el-form-item label="Signature of Parent/Guardian 家长签名:">
                <vue-esign
                  ref="medicine"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="medicineReset" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 家长姓名打印:">
                  <el-input
                    v-model="medicine.parent_print"
                    :disabled="disabledMap.medicine.parent_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="medicine.parent_date"
                    :disabled="disabledMap.medicine.parent_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="width20"></div>
            <h4 style="width: 96%; font-size: 14px; margin: 0 auto">
              If the Student is 18 years of age or over on the date of signing,
              then the Student’s signature is required.
              <br />如果签字时，学生已满 18 岁或 18 岁以上，该生也必须签字。
            </h4>
            <div class="width20"></div>
            <div class="person flex-sb">
              <el-form-item label="Signature of Student 学生姓名签字:">
                <vue-esign
                  ref="medicine1"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="medicineReset1" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 学生姓名打印:">
                  <el-input
                    v-model="medicine.student_print"
                    :disabled="disabledMap.medicine.student_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="medicine.student_date"
                    :disabled="disabledMap.medicine.student_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>

        <div class="fenge" v-if="Message.page_two"></div>
        <!-- PERMISSION TO ACCESS STUDENT INFORMATION -->
        <div class="infomation" v-if="Message.page_three">
          <h3>PERMISSION TO ACCESS STUDENT INFORMATION</h3>
          <div class="text">
            Supporting the laws and procedures outlined by FERPA, anyone who
            wishes to access student information at
            <el-input
              placeholder="please enter"
              v-model="info.info_school_name"
              :disabled="disabledMap.info.info_school_name"
              style="width: 30%"
            ></el-input>
            must have written permission from the student’s parent/or legal
            guardian. This form constitutes acknowledgment and permission from
            the parents/or legal guardians that the person(s) named below may
            have access to said students academic school information.<br />

            <div class="div flex-sb">
              <div class="div_fl">
                <div class="demo-input-suffix">
                  STUDENT NAME:
                  <el-input
                    placeholder="please enter"
                    v-model="info.info_student_name"
                    :disabled="disabledMap.info.info_student_name"
                  >
                  </el-input>
                </div>
              </div>
              <div class="div_fr">
                <div class="demo-input-suffix">
                  B.O.D:
                  <el-date-picker
                    v-model="info.info_bod"
                    :disabled="disabledMap.info.info_bod"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                    style="display: block; width: 180px"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="width20"></div>
            <div class="demo-input-suffix">
              DATES THAT ACCESS SHALLBE GRANTED:
              <el-date-picker
                v-model="info.info_visit_date"
                :disabled="disabledMap.info.info_visit_date"
                type="daterange"
                range-separator="TO"
                start-placeholder="start"
                end-placeholder="end"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>

            <div class="width20"></div>

            <div class="persons">
              <div class="title">PERSON OR PERSONS REQUESTING ACCESS:</div>
              <div class="div flex-sb">
                <div class="div_fl">
                  <div class="demo-input-suffix">
                    Name:
                    <el-input
                      placeholder="please enter"
                      v-model="info.info_teacher_name_one"
                      :disabled="disabledMap.info.info_teacher_name_one"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="div_fr">
                  <div class="demo-input-suffix">
                    Phone:
                    <el-input
                      placeholder="please enter"
                      v-model="info.info_teacher_phone_one"
                      :disabled="disabledMap.info.info_teacher_phone_one"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div class="demo-input-suffix">
                Address:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_teacher_address_one"
                  :disabled="disabledMap.info.info_teacher_address_one"
                  type="textarea"
                >
                </el-input>
              </div>

              <div class="demo-input-suffix">
                Email Address:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_teacher_email_one"
                  :disabled="disabledMap.info.info_teacher_email_one"
                  type="textarea"
                >
                </el-input>
              </div>

              <div class="demo-input-suffix">
                Relationship to Student:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_teacher_relation_one"
                  :disabled="disabledMap.info.info_teacher_relation_one"
                >
                </el-input>
              </div>
            </div>
            <div class="persons">
              <div class="title">
                NAME OF PARENT AND/OR LEGAL GUARDIAN AUTHORIZING RELEASE:
              </div>
              <div class="div flex-sb">
                <div class="div_fl">
                  <div class="demo-input-suffix">
                    Name:
                    <el-input
                      placeholder="please enter"
                      v-model="info.info_parent_name"
                      :disabled="disabledMap.info.info_parent_name"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="div_fr">
                  <div class="demo-input-suffix">
                    Phone:
                    <el-input
                      placeholder="please enter"
                      v-model="info.info_parent_phone"
                      :disabled="disabledMap.info.info_parent_phone"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div class="demo-input-suffix">
                Address:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_parent_address"
                  :disabled="disabledMap.info.info_parent_address"
                  type="textarea"
                >
                </el-input>
              </div>

              <div class="demo-input-suffix">
                Email Address:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_parent_email"
                  :disabled="disabledMap.info.info_parent_email"
                  type="textarea"
                >
                </el-input>
              </div>

              <div class="demo-input-suffix">
                Relationship to Student:
                <el-input
                  placeholder="please enter"
                  v-model="info.info_parent_relation"
                  :disabled="disabledMap.info.info_parent_relation"
                >
                </el-input>
              </div>
            </div>
            <div class="width20"></div>
            As parent and/or legal guardian of
            <el-input
              v-model="info.info_guardian"
              :disabled="disabledMap.info.info_guardian"
              style="width: 30%"
              placeholder="please enter"
            ></el-input>
            I here by authorize
            <el-input
              style="width: 30%"
              v-model="info.info_live"
              :disabled="disabledMap.info.info_live"
              placeholder="please enter"
            ></el-input>
            to allow access of student information to the person(s) mentioned
            above.
          </div>
          <div class="width20"></div>
          <div class="width20"></div>
          <el-form class="demo-ruleForm">
            <div class="person flex-sb">
              <el-form-item label="Signature of Parent/Guardian 家长签名:">
                <vue-esign
                  ref="info"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="infoReset" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 家长姓名打印:">
                  <el-input
                    v-model="info.parent_print"
                    :disabled="disabledMap.info.parent_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="info.parent_date"
                    :disabled="disabledMap.info.parent_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="width20"></div>
          </el-form>
        </div>
        <div class="fenge" v-if="Message.page_three"></div>
        <!-- 外出知情及免责声明 -->
        <div class="Exemption" v-if="Message.page_four">
          <h3>Liability Releas 外出知情及免责声明</h3>
          <div class="text">
            <div class="en">
              <el-input
                v-model="out.out_en_guardian"
                :disabled="disabledMap.out.out_en_guardian"
                placeholder="Please enter your parent name"
                class="Exemption-input"
              ></el-input>
              agree that
              <el-input
                v-model="out.out_en_student_name"
                :disabled="disabledMap.out.out_en_student_name"
                placeholder="Please enter student name"
                class="Exemption-input"
              ></el-input>
              is allowed to leave her/his homestay from<el-date-picker
                v-model="out.out_date"
                :disabled="disabledMap.out.out_date"
                type="daterange"
                range-separator="TO"
                start-placeholder="start date"
                end-placeholder="end date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              and can go shopping,entertainment or participate in other
              activities nearby alone.
              <div class="width20"></div>
              The supervisory organizations Heritage Student Foundation, and the
              student's homestay family accept no responsibility for any
              consequences of the student's absence.<br />
              As parents, we are aware of and agree to the above actions, and
              parents and students bear full responsibility for any accidents or
              illegal activities that may occur during the travel.The
              supervisory organizations Heritage Student Foundation and the
              student's homestay family shall not be held liable for any
              consequences.
            </div>

            <div class="chinese">
              <el-input
                v-model="out.out_guardian"
                :disabled="disabledMap.out.out_guardian"
                placeholder="请输入父母姓名"
                class="Exemption-input"
              ></el-input>
              同意
              <el-input
                v-model="out.out_student_name"
                :disabled="disabledMap.out.out_student_name"
                placeholder="请输入学生姓名"
                class="Exemption-input"
              ></el-input>
              ，在<el-date-picker
                v-model="out.out_date"
                :disabled="disabledMap.out.out_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              期间可以离开她/她的寄宿家庭，可以独自在附近购物、娱乐或参加其他活动。
              管理机构 Heritage Student Foundation
              和学生的寄宿家庭对学生外出期间的任何后果概不负责。<br />
              作为家长，我们知情并同意以上行为，并且家长及学生对过程中可能发生的任何
              事故或非法活动承担全部责任。管理机构 Heritage Student Foundation
              和学生寄宿家庭不承担任何责任。
            </div>
          </div>
          <div class="width20"></div>
          <el-form class="demo-ruleForm">
            <div class="person flex-sb">
              <el-form-item label="Signature of Parent/Guardian 家长签名:">
                <vue-esign
                  ref="out"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="outReset" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 家长姓名打印:">
                  <el-input
                    v-model="out.parent_print"
                    :disabled="disabledMap.out.parent_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="out.parent_date"
                    :disabled="disabledMap.out.parent_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="width20"></div>
            <h4 style="width: 96%; font-size: 14px; margin: 0 auto">
              If the Student is 18 years of age or over on the date of signing,
              then the Student’s signature is required.
              <br />如果签字时，学生已满 18 岁或 18 岁以上，该生也必须签字。
            </h4>
            <div class="width20"></div>
            <div class="person flex-sb">
              <el-form-item label="Signature of Student 学生姓名签字:">
                <vue-esign
                  ref="out1"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="outReset1" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 学生姓名打印:">
                  <el-input
                    v-model="out.student_print"
                    :disabled="disabledMap.out.student_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="out.student_date"
                    :disabled="disabledMap.out.student_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div class="fenge" v-if="Message.page_four"></div>
        <!-- 独自乘坐飞机授权 -->
        <div class="alone_plan" v-if="Message.page_five">
          <h1>Parents Approval for Minor to Travel Alone</h1>
          <h3>独自乘坐飞机授权</h3>
          <div class="text">
            Student Name 学生名字:
            <el-input
              v-model="plane.student_name"
              :disabled="disabledMap.plane.student_name"
            ></el-input>
            Passport Number 护照号码：
            <el-input
              v-model="plane.passport_no"
              :disabled="disabledMap.plane.passport_no"
            ></el-input>
            Phone number for contact in America 学生在美联系电话:<el-input
              v-model="plane.student_phone"
              :disabled="disabledMap.plane.student_phone"
            ></el-input>
            Need the airport pick up service 是否需要接机 :
            &nbsp;<el-radio-group
              v-model="plane.is_pick"
              :disabled="disabledMap.plane.is_pick"
            >
              <el-radio label="0">YES</el-radio>
              <el-radio label="1">NO</el-radio>
            </el-radio-group>
            <br />
            If no ，when will you arrive at school/ host family? Please
            specify：<br />
            如果不需要接机，学生将会在什么时间到达学校/寄宿家庭，请详细说明：<el-input
              type="textarea"
              v-model="plane.plane_details"
              :disabled="disabledMap.plane.plane_details"
            ></el-input>
            学生是否有人陪同：<el-radio-group
              v-model="plane.is_escort"
              :disabled="disabledMap.plane.is_escort"
            >
              <el-radio label="0">YES</el-radio>
              <el-radio label="1">NO</el-radio>
            </el-radio-group>
            <br />
            如果有，陪同人与学生的关系:<el-input
              v-model="plane.student_relation"
              :disabled="disabledMap.plane.student_relation"
            ></el-input>
            陪同人姓名：<el-input
              v-model="plane.plane_escort_name"
              :disabled="disabledMap.plane.plane_escort_name"
            ></el-input>
            陪同人联系电话：
            <el-input
              v-model="plane.plane_escort_phone"
              :disabled="disabledMap.plane.plane_escort_phone"
            ></el-input>
            <div class="width20"></div>
            <div class="father_name">
              We,
              <el-input
                v-model="plane.plane_en_father"
                :disabled="disabledMap.plane.plane_en_father"
              ></el-input
              >(Child’s Father)TEL NO.
              <el-input
                v-model="plane.plane_en_father_phone"
                :disabled="disabledMap.plane.plane_en_father_phone"
              ></el-input
              >and
              <el-input
                v-model="plane.plane_en_mother"
                :disabled="disabledMap.plane.plane_en_mother"
              ></el-input>
              (Child’s Mother),TEL NO.<el-input
                v-model="plane.plane_en_mother_phone"
                :disabled="disabledMap.plane.plane_en_mother_phone"
              ></el-input>
              approval travel alone for my child as follows:<el-input
                type="textarea"
                v-model="plane.plane_en_info"
                :disabled="disabledMap.plane.plane_en_info"
              ></el-input>

              我们，<el-input
                v-model="plane.plane_father"
                :disabled="disabledMap.plane.plane_father"
              ></el-input
              >（孩子的父亲姓名）联系电话<el-input
                v-model="plane.plane_father_phone"
                :disabled="disabledMap.plane.plane_father_phone"
              ></el-input
              >和
              <el-input
                v-model="plane.plane_mother"
                :disabled="disabledMap.plane.plane_mother"
              ></el-input
              >（孩子的母亲姓名）联系电话<el-input
                v-model="plane.plane_mother_phone"
                :disabled="disabledMap.plane.plane_mother_phone"
              ></el-input
              >同意我们的孩子独自出行，信息如下：<el-input
                v-model="plane.plane_info"
                :disabled="disabledMap.plane.plane_info"
                placeholder="（此处填写航班具体信息）"
                style="width: 40%"
              ></el-input>
            </div>
            <div class="width20"></div>

            我们知晓并允许我们的孩子独自一人出行前去美国，特此证明。<br />
            We hereby certify that we know and allow our child to travel alone
            to the United States.
            <!-- 父母联系信息<br> -->

            <el-form class="demo-ruleForm">
              <div class="person flex-sb">
                <el-form-item label="Signature of Parent/Guardian 家长签名:">
                  <vue-esign
                    ref="plane"
                    class="mySign"
                    :isCrop="isCrop"
                    :lineColor="lineColor"
                    :bgColor.sync="bgColor"
                  />
                  <el-button @click="planeReset" class="handleReset"
                    >reset</el-button
                  >
                </el-form-item>

                <div class="div">
                  <el-form-item label="Print Name 家长姓名打印:">
                    <el-input
                      v-model="plane.parent_print"
                      :disabled="disabledMap.plane.parent_print"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Date 日期:" prop="Date">
                    <el-date-picker
                      v-model="plane.parent_date"
                      :disabled="disabledMap.plane.parent_date"
                      type="date"
                      placeholder="(mm/dd/yyyy)"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="width20"></div>
              <h4 style="width: 96%; font-size: 14px; margin: 0 auto">
                If the Student is 18 years of age or over on the date of
                signing, then the Student’s signature is required.
                <br />如果签字时，学生已满 18 岁或 18 岁以上，该生也必须签字。
              </h4>
              <div class="width20"></div>
              <div class="person flex-sb">
                <el-form-item label="Signature of Student 学生姓名签字:">
                  <vue-esign
                    ref="plane1"
                    class="mySign"
                    :isCrop="isCrop"
                    :lineColor="lineColor"
                    :bgColor.sync="bgColor"
                  />
                  <el-button @click="planeReset1" class="handleReset"
                    >reset</el-button
                  >
                </el-form-item>

                <div class="div">
                  <el-form-item label="Print Name 学生姓名打印:">
                    <el-input
                      v-model="plane.student_print"
                      :disabled="disabledMap.plane.student_print"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Date 日期:" prop="Date">
                    <el-date-picker
                      v-model="plane.student_date"
                      :disabled="disabledMap.plane.student_date"
                      type="date"
                      placeholder="(mm/dd/yyyy)"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="fenge" v-if="Message.page_five"></div>

        <div class="Admission" v-if="Message.page_six">
          <h3>
            In Cooperation with High School Matriculation Documents Confirmation
            -
          </h3>
          <div class="text">
            The school-related and homestay-related documents above include
            Agreement for International Student Homestay Program，Permission for
            Guardian Power and Medical Care，Permission to Access Student
            Information，Parents Approval for Minor to Travel Alone，Liability
            Release. <br />
            以上入学及入住文件包含：
            <div class="div" v-if="Message.page_one">《寄宿家庭项目协议》</div>
            <div class="div" v-if="Message.page_two">
              《监护人授权和医疗授权同意书》
            </div>
            <div class="div" v-if="Message.page_three">
              《授权成绩单账户查询》
            </div>
            <div class="div" v-if="Message.page_four">
              《外出知情及免责声明》
            </div>
            <div class="div" v-if="Message.page_five">《独自乘坐飞机授权》</div>
            <div class="width20"></div>
            I certify that I have read, reviewed carefully, and consent to all
            that is stated in these documents above. I hereby certify that all
            the information provided in this school enrollment and homestay
            move-in materials is true. I understand and agree that any false
            statements, forgery or omission of information provided in this
            school enrollment and homestay move-in material package may result
            in expulsion from the school and termination of services by the
            host.
            <br />
            我已阅读并知情以上相关文件内容，并同意以上内容的要求。我在此证明，此入学及入住材料提供的所有信息均是真实。我了解并同意在此入学及入住材料包所提供的任何信息若有虚假陈述、伪造或遗漏信息，可能导致被学校开除以及住家停止服务。
            <div class="width20"></div>
            This Authorization is written in the English language. In case of
            discrepancies between the English text version of this Authorization
            and any translation, the English version shall prevail. All pronouns
            and any variation thereof refer to the masculine, feminine or
            neuter, singular or plural, as the identity of the person or persons
            may require.
            <br />
            该授权书用英文书写。如果在该授权同意书的英文版本与其他翻译版本有差异时，以英文版本为准。根据个人或某些人身份的需要，所有
            的代词和任何其他变化形式，特指男性，女性或中性，单数或者复数。
            <div class="width20"></div>
            Photocopies of this Authorization shall have the same force and
            effect as the original. I authorize the Custodian and the School to
            share copies of this Authorization with the host family or
            residential services provider, HSF Network and its boards,
            commissions, committees, employees, officers, directors, servants,
            agents, and assigns.<br />
            以上文件复印件应具有与原件相同的效力。我授权代理人和学校可以与住宿家庭或住宿服务提供方，HSF
            及其董事会，委员会，常设委员会，雇员，管理人员，董事，服务人员，代理和受让人共享以上文件。
            <div class="width20"></div>
            本人已通读前述全部文件内容，文件各位置签名与文末最终签名法律效力完全等同，均代表本人真实认可文件全部条款。
          </div>
          <div class="width20"></div>
          <el-form class="demo-ruleForm" ref="form">
            <div class="person flex-sb">
              <el-form-item label="Signature of Parent/Guardian 家长签名:">
                <vue-esign
                  ref="esign"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="handleReset" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 家长姓名打印:">
                  <el-input
                    v-model="confirm.parent_print"
                    :disabled="disabledMap.confirm.parent_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="confirm.parent_date"
                    :disabled="disabledMap.confirm.parent_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="width20"></div>
            <h4 style="width: 96%; font-size: 14px; margin: 0 auto">
              If the Student is 18 years of age or over on the date of signing,
              then the Student’s signature is required.
              <br />如果签字时，学生已满 18 岁或 18 岁以上，该生也必须签字。
            </h4>
            <div class="width20"></div>
            <div class="person flex-sb">
              <el-form-item label="Signature of Student 学生姓名签字:">
                <vue-esign
                  ref="esign1"
                  class="mySign"
                  :isCrop="isCrop"
                  :lineColor="lineColor"
                  :bgColor.sync="bgColor"
                />
                <el-button @click="handleReset1" class="handleReset"
                  >reset</el-button
                >
              </el-form-item>

              <div class="div">
                <el-form-item label="Print Name 学生姓名打印:">
                  <el-input
                    v-model="confirm.student_print"
                    :disabled="disabledMap.confirm.student_print"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Date 日期:" prop="Date">
                  <el-date-picker
                    v-model="confirm.student_date"
                    :disabled="disabledMap.confirm.student_date"
                    type="date"
                    placeholder="(mm/dd/yyyy)"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>

        <div class="div" style="width: 100%; text-align: right">
          <el-button
            type="primary"
            @click="onSubmit"
            v-if="this.$route.query.type"
            >提交 submit</el-button
          >
          <el-button
            type="success"
            @click="SaveLink()"
            style="margin-right: auto"
            v-if="!this.$route.query.type"
            >Save 保存</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="Your progress has been saved."
      :visible.sync="dialogFormVisible"
    >
      <div class="text">
        Copy or email the link below and return to your form to complete your
        submission.
      </div>
      <el-form>
        <el-form-item label="Copy your form link:">
          <el-input v-model="savelink" autocomplete="off"></el-input>
        </el-form-item>

        <el-button type="primary" @click="CopyLink()">复制链接</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Operator, FileSubmit, FileSave } from "@/api/home";
import HomestayAgreementC from "@/components/HomestayAgreementC.vue";
export default {
  components: {
    HomestayAgreementC,
  },
  data() {
    return {
      dialogFormVisible: false,
      savelink: "", // 回显链接
      Message: [],
      disabledMap: {
        ishp: {
          student_name: "",
          date_of_birth: "",
          passport_no: "",
          validity_period: "",
          enter_season: "",
          transfer_count: "",
          student_signature: "",
          student_print: "",
          student_date: "",
          parent_date: "",
          parent_print: "",
          student_date: "",
          student_print: "",
        },

        medicine: {
          medicine_guardian: "",
          medicine_en_guardian: "",
          medicine_student_name: "",
          medicine_en_student_name: "",
          medicine_live_name: "",
          medicine_en_live_name: "",
          medicine_start_time: "",
          medicine_end_time: "",
          parent_date: "",
          parent_print: "",
          student_date: "",
          student_print: "",
        },

        info: {
          info_school_name: "",
          info_student_name: "",
          info_visit_start_time: "",
          info_visit_end_time: "",
          info_guardian: "",
          info_live: "",
          info_guardian_signature: "",
          info_date: "",
          info_teacher_name_one: "",
          info_teacher_address_one: "",
          info_teacher_email_one: "",
          info_teacher_phone_one: "",
          info_teacher_relation_one: "",
          info_teacher_name_two: "",
          info_teacher_address_two: "",
          info_teacher_email_two: "",
          info_teacher_phone_two: "",
          info_teacher_relation_two: "",
          info_parent_name: "",
          info_parent_address: "",
          info_parent_email: "",
          info_parent_phone: "",
          info_parent_relation: "",
          parent_signature: "",
          parent_date: "",
          parent_print: "",
        },

        out: {
          out_guardian: "",
          out_student_name: "",
          out_en_guardian: "",
          out_en_student_name: "",
          out_date: [],
          parent_date: "",
          parent_print: "",
          student_date: "",
          student_print: "",
        },

        plane: {
          plane_escort_name: "",
          plane_escort_phone: "",
          plane_father: "",
          plane_mother: "",
          plane_father_phone: "",
          plane_mother_phone: "",
          plane_info: "",
          plane_en_father: "",
          plane_en_mother: "",
          plane_en_father_phone: "",
          plane_en_mother_phone: "",
          plane_en_info: "",
          contract_id: "",
          student_name: "",
          passport_no: "",
          student_phone: "",
          is_pick: "",
          is_escort: "",
          student_relation: "",
          plane_details: "",
          parent_signature: "",
          parent_print: "",
          parent_date: "",
          student_signature: "",
          student_print: "",
          student_date: "",
        },

        confirm: {
          parent_date: "",
          student_date: "",
          student_print: "",
          parent_print: "",
          parent_signature: "", // 最终画布生成的base64图片
          student_signature: "",
        },
      },

      ishp: {
        is_long:1,
        student_name: "",
        date_of_birth: "",
        passport_no: "",
        is_need: "",
        validity_period: "",
        enter_season: "",
        transfer_count: "",
        student_signature: "",
        student_print: "",
        student_date: "",
        parent_date: "",
        parent_print: "",
        student_date: "",
        student_print: "",
      },

      medicine: {
        medicine_time: "",
        medicine_guardian: "",
        medicine_en_guardian: "",
        medicine_student_name: "",
        medicine_en_student_name: "",
        medicine_live_name: "",
        medicine_en_live_name: "",
        medicine_start_time: "",
        medicine_end_time: "",
        parent_date: "",
        parent_print: "",
        student_date: "",
        student_print: "",
      },

      info: {
        info_school_name: "",
        info_student_name: "",
        info_visit_start_time: "",
        info_visit_end_time: "",
        info_guardian: "",
        info_live: "",
        info_guardian_signature: "",
        info_date: "",
        info_teacher_name_one: "",
        info_teacher_address_one: "",
        info_teacher_email_one: "",
        info_teacher_phone_one: "",
        info_teacher_relation_one: "",
        info_teacher_name_two: "",
        info_teacher_address_two: "",
        info_teacher_email_two: "",
        info_teacher_phone_two: "",
        info_teacher_relation_two: "",
        info_parent_name: "",
        info_parent_address: "",
        info_parent_email: "",
        info_parent_phone: "",
        info_parent_relation: "",
        parent_signature: "",
        parent_date: "",
        parent_print: "",
      },

      out: {
        out_guardian: "",
        out_student_name: "",
        out_en_guardian: "",
        out_en_student_name: "",
        out_date: [],
        parent_date: "",
        parent_print: "",
        student_date: "",
        student_print: "",
      },

      plane: {
        plane_escort_name: "",
        plane_escort_phone: "",
        plane_father: "",
        plane_mother: "",
        plane_father_phone: "",
        plane_mother_phone: "",
        plane_info: "",
        plane_en_father: "",
        plane_en_mother: "",
        plane_en_father_phone: "",
        plane_en_mother_phone: "",
        plane_en_info: "",
        contract_id: "",
        student_name: "",
        passport_no: "",
        student_phone: "",
        is_pick: "",
        is_escort: "",
        student_relation: "",
        plane_details: "",
        parent_signature: "",
        parent_print: "",
        parent_date: "",
        student_signature: "",
        student_print: "",
        student_date: "",
      },

      confirm: {
        parent_date: "",
        student_date: "",
        student_print: "",
        parent_print: "",
        parent_signature: "", // 最终画布生成的base64图片
        student_signature: "",
      },

      lineWidth: 2, // 画笔的线条粗细
      lineColor: "#000000", // 画笔的颜色
      bgColor: "", // 画布的背景颜色
      isCrop: false, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      Sign: {}, //签名数据
      syncingPrintName: false,
      syncingDate: false,
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var type = this.$route.query.type;
    Operator({ id: id }).then((res) => {
      if (res.code == 200) {
        this.Message = res.data;
        this.ishp = this.Message.ishp;
        this.medicine = this.Message.medicine;
        this.info = this.Message.info;
        this.out = this.Message.out;
        this.plane = this.Message.plane;
        this.confirm = this.Message.confirm;
        this.ensureSharedFields();
        this.syncExistingPrintNames();
        this.syncExistingDates();
        this.MountedDisable();
      }
    });

    const ishp = localStorage.getItem("ishp");
    const medicine = localStorage.getItem("medicine");
    const info = localStorage.getItem("info");
    const out = localStorage.getItem("out");
    const plane = localStorage.getItem("plane");
    const confirm = localStorage.getItem("confirm");
    if (medicine) {
      this.medicine = JSON.parse(medicine);
    }
    if (ishp) {
      this.ishp = JSON.parse(ishp);
    }
    if (info) {
      this.info = JSON.parse(info);
    }
    if (out) {
      this.out = JSON.parse(out);
    }
    if (plane) {
      this.plane = JSON.parse(plane);
    }
    if (confirm) {
      this.confirm = JSON.parse(confirm);
    }
    this.ensureSharedFields();
    this.syncExistingPrintNames();
    this.syncExistingDates();
  },
  computed: {
    agreementType() {
      return String(this.Message.type || 2);
    },
  },
  methods: {
    ChangeRadio(val){
      console.log(val);
    },

    ClearLoca() {
      window.localStorage.clear();
    },

    isSectionSelected(section) {
      const pageBySection = {
        ishp: "page_one",
        medicine: "page_two",
        info: "page_three",
        out: "page_four",
        plane: "page_five",
        confirm: "page_six",
      };
      return Boolean(this.Message[pageBySection[section]]);
    },

    printNameSections(field) {
      const sectionsByField = {
        parent_print: ["ishp", "medicine", "info", "out", "plane", "confirm"],
        student_print: ["ishp", "medicine", "out", "plane", "confirm"],
        parent_date: ["ishp", "medicine", "info", "out", "plane", "confirm"],
        student_date: ["ishp", "medicine", "out", "plane", "confirm"],
      };
      return (sectionsByField[field] || []).filter(
        (section) => this[section] && this.isSectionSelected(section)
      );
    },

    ensureSharedFields() {
      ["parent_print", "student_print", "parent_date", "student_date"].forEach(
        (field) => {
          this.printNameSections(field).forEach((section) => {
            if (!(field in this[section])) {
              this.$set(this[section], field, "");
            }
          });
        }
      );
    },

    firstFilledValue(field) {
      const sections = this.printNameSections(field);
      for (const section of sections) {
        const value = this[section][field];
        if (value !== null && value !== undefined && value !== "") {
          return value;
        }
      }
      return "";
    },

    syncExistingPrintNames() {
      const parentPrint = this.firstFilledValue("parent_print");
      const studentPrint = this.firstFilledValue("student_print");

      if (parentPrint) {
        this.syncPrintName("parent_print", parentPrint);
      }
      if (studentPrint) {
        this.syncPrintName("student_print", studentPrint);
      }
    },

    syncPrintName(field, value) {
      if (this.syncingPrintName) {
        return;
      }

      this.syncingPrintName = true;
      this.printNameSections(field).forEach((section) => {
        if (this[section][field] !== value) {
          this.$set(this[section], field, value);
        }
      });
      this.syncingPrintName = false;
    },

    syncExistingDates() {
      const parentDate = this.firstFilledValue("parent_date");
      const studentDate = this.firstFilledValue("student_date");

      if (parentDate) {
        this.syncDate("parent_date", parentDate);
      }
      if (studentDate) {
        this.syncDate("student_date", studentDate);
      }
    },

    syncDate(field, value) {
      if (this.syncingDate) {
        return;
      }

      this.syncingDate = true;
      this.printNameSections(field).forEach((section) => {
        if (this[section][field] !== value) {
          this.$set(this[section], field, value);
        }
      });
      this.syncingDate = false;
    },

    async generateSignature(refName) {
      const [componentRef, methodName] = refName.split(".");
      const signatureRef = this.$refs[componentRef];
      if (!signatureRef) {
        return "";
      }

      try {
        if (methodName && typeof signatureRef[methodName] === "function") {
          return await signatureRef[methodName]();
        }
        return await signatureRef.generate();
      } catch (error) {
        return "";
      }
    },

    firstFilledSignature(field, sections) {
      for (const section of sections) {
        if (
          this[section] &&
          this[section][field] !== null &&
          this[section][field] !== undefined &&
          this[section][field] !== ""
        ) {
          return this[section][field];
        }
      }
      return "";
    },

    async syncSignatureGroup(field, signatureList, requiredMessage, required) {
      const selectedSignatureList = signatureList.filter((item) =>
        this.isSectionSelected(item.section)
      );
      let signature = "";

      for (const item of selectedSignatureList) {
        signature = await this.generateSignature(item.ref);
        if (signature) {
          break;
        }
      }

      if (!signature) {
        signature = this.firstFilledSignature(
          field,
          selectedSignatureList.map((item) => item.section)
        );
      }

      if (!signature) {
        if (required) {
          this.$message.error(requiredMessage);
        }
        return false;
      }

      selectedSignatureList.forEach((item) => {
        if (this[item.section]) {
          this.$set(this[item.section], field, signature);
        }
      });

      return true;
    },

    async syncAllSignatures(required) {
      const parentSynced = await this.syncSignatureGroup(
        "parent_signature",
        [
          { section: "confirm", ref: "esign" },
          { section: "ishp", ref: "ishp" },
          { section: "ishp", ref: "ishpC.generateParentSignature" },
          { section: "medicine", ref: "medicine" },
          { section: "info", ref: "info" },
          { section: "out", ref: "out" },
          { section: "plane", ref: "plane" },
        ],
        "Parent signature is required",
        required
      );

      await this.syncSignatureGroup(
        "student_signature",
        [
          { section: "confirm", ref: "esign1" },
          { section: "ishp", ref: "ishp1" },
          { section: "ishp", ref: "ishpC.generateStudentSignature" },
          { section: "medicine", ref: "medicine1" },
          { section: "out", ref: "out1" },
          { section: "plane", ref: "plane1" },
        ],
        "Student signature is required",
        false
      );

      return !required || parentSynced;
    },

    // 执行disable操作
    MountedDisable() {
      const sectionKeys = [
        "ishp",
        "medicine",
        "info",
        "out",
        "plane",
        "confirm",
      ];
      sectionKeys.forEach((section) => {
        const sectionData = this[section];
        const disabledSection = {};
        for (const key in sectionData) {
          const val = sectionData[key];
          disabledSection[key] = Array.isArray(val)
            ? val.length > 0
            : val !== null && val !== "";
        }
        ["parent_print", "student_print", "parent_date", "student_date"].forEach(
          (field) => {
            if (field in disabledSection) {
              disabledSection[field] = false;
            }
          }
        );
        this.disabledMap[section] = disabledSection;
      });
    },

    CopyLink() {
      const input = document.createElement("textarea"); // 创建一个隐藏的 textarea
      input.value = this.savelink;
      document.body.appendChild(input);
      input.select(); // 选中文本
      input.setSelectionRange(0, input.value.length); // 兼容 iOS
      const result = document.execCommand("copy"); // 执行复制
      document.body.removeChild(input); // 移除临时元素
      this.$message.success("复制成功");
    },

    async SaveLink() {
      await this.syncAllSignatures(false);
      // 通过接口提交
      var id = this.$route.query.id;
      var url = window.location.href;
      FileSave({
        id: id,
        type: Number(this.agreementType),
        ishp: this.ishp,
        medicine: this.medicine,
        info: this.info,
        out: this.out,
        plane: this.plane,
        confirm: this.confirm,
      }).then((res) => {
        if (res.code == 200) {
          this.savelink = `${url}&type=edit`;
          this.dialogFormVisible = !this.dialogFormVisible;
          this.$message({
            message: "文件保存成功",
            type: "success",
          });
        }
      });
    },
    // onSubmit() {
    //     this.handleGenerate();
    //     this.handleGenerate1();
    //     console.log(this.form, this.alon, this.Releas, this.info);
    //     console.log(this.resultImg,this.resultImg1,22222222222222)
    // },

    async submitData() {
      var id = this.$route.query.id;
      FileSubmit({
        id: id,
        type: Number(this.agreementType),
        ishp: this.ishp,
        medicine: this.medicine,
        info: this.info,
        out: this.out,
        plane: this.plane,
        confirm: this.confirm,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "合同协议提交成功",
            type: "success",
          });
          //清空缓存数据
          // this.ClearLoca();
        }
      });
      // 实际的提交逻辑，如 axios.post(...)
    },
    async onSubmit() {
      try {
        const signatureReady = await this.syncAllSignatures(true);
        if (!signatureReady) {
          return;
        }
        await this.submitData();
      } catch (error) {
        console.error("提交失败：", error);
      }
    },

    handleGenerate() {
      if (this.$refs.esign) {
        this.$refs.esign
          .generate()
          .then((res) => {
            this.confirm.parent_signature = res;
          })
          .catch((err) => {
            this.$message.error("入学文件确认家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
          });
      }
    },

    handleGenerate1() {
      if (this.$refs.esign1) {
        this.$refs.esign1.generate().then((res) => {
          this.confirm.student_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("入学文件确认学生未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },
    // 寄宿家庭协议
    ishpGenerate() {
      if (this.$refs.ishp) {
        this.$refs.ishp
          .generate()
          .then((res) => {
            this.ishp.parent_signature = res;
          })
          .catch((err) => {
            this.$message.error("寄宿家庭协议家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
          });
      }
    },
    ishpGenerate1() {
      if (this.$refs.ishp1) {
        this.$refs.ishp1.generate().then((res) => {
          this.ishp.student_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("寄宿家庭协议学生未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },
    // 监护人授权和医药授权同
    medicineGenerate() {
      if (this.$refs.medicine) {
        this.$refs.medicine
          .generate()
          .then((res) => {
            this.medicine.parent_signature = res;
          })
          .catch((err) => {
            this.$message.error("医疗授权家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
          });
      }
    },
    medicineGenerate1() {
      if (this.$refs.medicine1) {
        this.$refs.medicine1.generate().then((res) => {
          this.medicine.student_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("医疗授权学生未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },

    // 成绩单授权
    infoGenerate1() {
      if (this.$refs.info) {
        this.$refs.info.generate().then((res) => {
          this.info.parent_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("成绩单授权家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },
    // 外出知情及免责声明
    outGenerate() {
      if (this.$refs.out) {
        this.$refs.out
          .generate()
          .then((res) => {
            this.out.parent_signature = res;
          })
          .catch((err) => {
            this.$message.error("外出免责声明家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
          });
      }
    },

    outGenerate1() {
      if (this.$refs.out1) {
        this.$refs.out1.generate().then((res) => {
          this.out.student_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("外出免责声明学生未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },
    // 独自乘坐飞机授权
    planeGenerate() {
      if (this.$refs.plane) {
        this.$refs.plane
          .generate()
          .then((res) => {
            this.plane.parent_signature = res;
          })
          .catch((err) => {
            this.$message.error("独自乘坐飞机授权家长未签字"); // 画布没有签字时会执行这里 'Not Signned'
          });
      }
    },
    planeGenerate1() {
      if (this.$refs.plane1) {
        this.$refs.plane1.generate().then((res) => {
          this.plane.student_signature = res;
        });
        // .catch((err) => {
        //   this.$message.error("独自乘坐飞机授权学生未签字"); // 画布没有签字时会执行这里 'Not Signned'
        // });
      }
    },
    //清空
    handleReset() {
      this.$refs.esign.reset();
    },
    //清空
    handleReset1() {
      this.$refs.esign1.reset();
    },
    infoReset() {
      this.$refs.info.reset();
    },
    ishpReset() {
      this.$refs.ishp.reset();
    },
    ishpReset1() {
      this.$refs.ishp1.reset();
    },
    outReset() {
      this.$refs.out.reset();
    },
    outReset1() {
      this.$refs.out1.reset();
    },
    medicineReset() {
      this.$refs.medicine.reset();
    },
    medicineReset1() {
      this.$refs.medicine1.reset();
    },
    planeReset() {
      this.$refs.plane.reset();
    },
    planeReset1() {
      this.$refs.plane1.reset();
    },
  },
  watch: {
    ishp: {
      handler(val) {
        localStorage.setItem("ishp", JSON.stringify(val));
      },
      deep: true,
    },

    medicine: {
      handler(val) {
        localStorage.setItem("medicine", JSON.stringify(val));
      },
      deep: true,
    },

    info: {
      handler(val) {
        localStorage.setItem("info", JSON.stringify(val));
      },
      deep: true,
    },

    out: {
      handler(val) {
        localStorage.setItem("out", JSON.stringify(val));
      },
      deep: true,
    },

    plane: {
      handler(val) {
        localStorage.setItem("plane", JSON.stringify(val));
      },
      deep: true,
    },
    confirm: {
      handler(val) {
        localStorage.setItem("confirm", JSON.stringify(val));
      },
      deep: true,
    },
    "ishp.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "medicine.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "info.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "out.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "plane.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "confirm.parent_print"(val) {
      this.syncPrintName("parent_print", val);
    },
    "ishp.student_print"(val) {
      this.syncPrintName("student_print", val);
    },
    "medicine.student_print"(val) {
      this.syncPrintName("student_print", val);
    },
    "out.student_print"(val) {
      this.syncPrintName("student_print", val);
    },
    "plane.student_print"(val) {
      this.syncPrintName("student_print", val);
    },
    "confirm.student_print"(val) {
      this.syncPrintName("student_print", val);
    },
    "ishp.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "medicine.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "info.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "out.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "plane.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "confirm.parent_date"(val) {
      this.syncDate("parent_date", val);
    },
    "ishp.student_date"(val) {
      this.syncDate("student_date", val);
    },
    "medicine.student_date"(val) {
      this.syncDate("student_date", val);
    },
    "out.student_date"(val) {
      this.syncDate("student_date", val);
    },
    "plane.student_date"(val) {
      this.syncDate("student_date", val);
    },
    "confirm.student_date"(val) {
      this.syncDate("student_date", val);
    },
  },
};
</script>

<style lang="scss" scoped>
#Ishp{
  position: relative;
  .div_radio{
    position: absolute;
    right: 0px;
    top:0px
  }
  .months{
    display: inline-block
  }
}
@media screen and (max-width: 480px) {
  h1 {
    font-size: 22px;
  }

  h3 {
    font-size: 18px;
  }

  .student_name {
    width: 50% !important;
  }

  .residence_time {
    width: 30% !important;
  }

  .father_name {
    .el-input {
      width: 30% !important;
    }
  }
}

.father_name {
  line-height: 60px;
}

.Permission {
  .text {
    line-height: 60px;
  }

  .infomation {
    width: 30%;
  }
}

.Exemption {
  .en {
    line-height: 50px;
  }

  .chinese {
    line-height: 50px;
  }

  .Exemption-input {
    width: 30%;
  }
}

.father_name {
  .el-input {
    width: 20%;
  }
}

.div_fl {
  width: 48%;
}

.div_fr {
  width: 48%;
}

.mySign {
  width: 450px !important;
  border: 1px solid #dcdfe6;
}

.flex-sb {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: "767px") {
  .person {
    display: inline-block !important;
  }
}

.width20 {
  width: 100%;
  height: 20px;
}

::v-deep .student_name {
  width: 30%;
  margin: 10px 0;
}

::v-deep .residence_time {
  width: 15%;
  margin: 10px 0;
}

.fenge {
  width: 100%;
  height: 10px;
  background: #eee;
  margin: 40px 0;
}

#home {
  width: 100%;
  min-width: 100%;
  min-height: 930px;
  background: rgba(204, 204, 204, 1);
  background-attachment: fixed;
  padding-bottom: 30px;

  .maxwidth {
    max-width: 1170px;
    background: #fff;
    margin: 0px auto;
    box-shadow: 0 0 10px hsla(0, 0%, 0%, 0.1), 1px 1px 2px hsla(0, 0%, 0%, 0.1);
    padding-bottom: 30px;

    .minwidth {
      width: 94%;
      margin: 0 auto;
      text-align: left;
      .text {
        font-size: 14px;
        line-height: 36px;
        color: #000000;

        .title {
          font-size: 16px;
          font-weight: bold;
          margin: 20px 0;
        }
      }

      h1 {
        padding: 20px 0 0 0;
        margin: 0px 0 20px 0;
        text-align: center;
        font-size: 28px;
      }

      h3 {
        text-align: center;
        margin: 10px 0 30px 0;
        font-size: 22px;
      }
    }
  }
}
</style>
